var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBlueThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72867 8.84204H5.5001V19.8947H1.72867C1.38152 19.8947 1.1001 19.514 1.1001 19.0445V9.69224C1.1001 9.22269 1.38152 8.84204 1.72867 8.84204Z",
    fill: "#115AD2",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 9.67098L9.12964 2.60492C9.66585 1.56093 10.9428 1.15143 11.9818 1.69025C12.1759 1.79092 12.3534 1.92116 12.5078 2.07636C13.1267 2.6982 13.4744 3.54158 13.4744 4.42098V7.73677H19.2503C19.7236 7.73677 20.1741 7.94097 20.4873 8.29747C20.8005 8.65396 20.9463 9.12844 20.8876 9.6003L19.6501 18.4424C19.5468 19.2721 18.8449 19.8947 18.0128 19.8947H5.5",
    fill: "#115AD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.67098L9.12964 2.60492C9.66585 1.56093 10.9428 1.15143 11.9818 1.69025C12.1759 1.79092 12.3534 1.92116 12.5078 2.07636C13.1267 2.6982 13.4744 3.54158 13.4744 4.42098V7.73677H19.2503C19.7236 7.73677 20.1741 7.94097 20.4873 8.29747C20.8005 8.65396 20.9463 9.12844 20.8876 9.6003L19.6501 18.4424C19.5468 19.2721 18.8449 19.8947 18.0128 19.8947H5.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlueThumb);
export default __webpack_public_path__ + "static/media/icon-blue-thumb.a39cd79e8342fb58ba21c9a93a7f5cee.svg";
export { ForwardRef as ReactComponent };